import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import experimentFlags, { CORE_POST_AUTH_NAV_V3 } from './experimentFlags';

export const isPostAuthNav3Active = (userContext: UserContext | null) => {
  if (!userContext || typeof window === 'undefined') {
    return false;
  }

  const experimentIsActive = experimentFlags.isUnderTest(CORE_POST_AUTH_NAV_V3, userContext, false);

  return experimentIsActive && !userContext.is_guest;
};
